import { render, staticRenderFns } from "./TermOfUse.vue?vue&type=template&id=5bbdc04e&scoped=true"
import script from "./TermOfUse.vue?vue&type=script&lang=js"
export * from "./TermOfUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbdc04e",
  null
  
)

export default component.exports